import React from "react";
import { Routes, Route } from "react-router-dom";
import ConsultantLogin from "../../pages/Consultant/ConsultantLogin";
import ConsultantSignup from "../../pages/Consultant/ConsultantSignup";
import ConsultantDashboard from "../../pages/Consultant/ConsultantDashboard";
import ConsultantSubscription from "../../pages/Consultant/ConsultantSubscription";
import ConsultantSubscriptionHistory from "../../pages/Consultant/ConsultantSubscriptionHistory";
import ForgotPassword from "../../pages/Consultant/ForgotPassword";

const ConsultantRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<ConsultantLogin />} />
            <Route path="/signup" element={<ConsultantSignup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<ConsultantDashboard />} />
            <Route path="/subscription" element={<ConsultantSubscription />} />
            <Route path="/subscription-history" element={<ConsultantSubscriptionHistory />} />
        </Routes>
    );
};

export default ConsultantRoutes;
